import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createQualityItem,
  getAllQualityItems,
  getDataForEdit,
  updateQualityItem,
  deleteQualityItem,
} from "../../store/Quality/QualityApi";

import { headTitle } from "../../utility/GetTableListName";
import { qualitySliceAction } from "../../store/Quality/QualitySlice";
import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsQuality } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialQualityFormData } from "../../ConstantData/InitialData";
//imporint form data error
import { ErrorFactoryFormData } from "../../ConstantData/ErrorOption";
function Quality() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAllQualityItems());
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const QualityList = useSelector((state) => state.quality.qualityList);
  const InitialFormDataStore = useSelector(
    (state) => state.quality.initialData
  );
  const qualityEditData = useSelector((state) => state.quality.dataEdit);
  let isError = useSelector((state) => state.quality.isError);
  let qualityFormError = useSelector((state) => state.quality.errorData);
  qualityFormError = { ...ErrorFactoryFormData, ...qualityFormError };
  const headTitleLabel = headTitle(FormOptionsQuality, ["Name"]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialQualityFormData}
      //function coming from store
      getDataForEdit={getDataForEdit}
      delteFun={deleteQualityItem}
      createFun={createQualityItem} //create function coming from store
      updateFun={updateQualityItem} //update function coming from store
      FormOptions={FormOptionsQuality}
      OptionName="Create Quality"
      OptionNameList="Quality"
      generalList={QualityList}
      headTitle={headTitleLabel}
      isError={isError}
      ErrorData={qualityFormError}
      setErrorData={qualitySliceAction.setErrorData}
      EditData={qualityEditData}
      InitialFormDataStore={InitialFormDataStore}
      isNotDeleteBtn={false}
      secondCreateBtn={false}
      isSuccess={isSuccess}
    />
  );
}

export default Quality;
